













	import Vue from 'vue';
	import Component from 'vue-class-component';

/** The next icon for slide group */
@Component
	export default class DownIcon extends Vue {}
